import popupError from '../../assets/Popups/popup-error.svg'
import popupInfo from '../../assets/Popups/popup-info.svg'
import popupNotice from '../../assets/Popups/popup-notice.svg'
import popupRebalancing from '../../assets/Popups/popup-rebalancing.svg'
import popupSuccess from '../../assets/Popups/popup-success.svg'

const popupGraphics = {
  success: popupSuccess,
  sipsuccess: popupSuccess,
  auto_approved: popupSuccess,
  info: popupInfo,
  app_update: popupInfo,
  nominee_confirmation: popupInfo,
  cvl_kra_pending: popupInfo,
  needs_review: popupInfo,
  notice: popupNotice,
  partial: popupNotice,
  rebalancing: popupRebalancing,
  user_cancelled: popupNotice,
  error: popupError,
  failure: popupError,
  failed: popupError,
  auto_declined: popupError,
}

export const getPopupGraphic = (severity) => popupGraphics[severity] || popupGraphics.notice

export const getPopupVisualSeverity = (severity) => {
  if (['success', 'sipsuccess', 'auto_approved'].includes(severity)) return 'success'
  if (['error', 'failed', 'failure', 'auto_declined'].includes(severity)) return 'error'
  if (
    ['info', 'app_update', 'nominee_confirmation', 'cvl_kra_pending', 'needs_review'].includes(
      severity,
    )
  ) {
    return 'info'
  }
  return 'notice'
}

export const getPopupLabel = (severity) => {
  const visualSeverity = getPopupVisualSeverity(severity)

  if (severity === 'rebalancing') return 'Rebalancing'
  if (severity === 'app_update') return 'Update'
  if (visualSeverity === 'success') return 'Success'
  if (visualSeverity === 'error') return 'Error'
  if (visualSeverity === 'info') return 'Information'
  return 'Notice'
}
